import { createModuleEpics } from "@app/modules/app.reducers";
import { Script } from "@ea/shared_types/types";

import { makeAsyncEpic } from "@app/modules/app.reducers";
import { API } from "@app/services/api/api";
import { createRequestParams } from "@ea/shared_components/redux/createRequestParams";
import { moduleActions, scriptsActionCreators } from "./scripts.actions";
import { scriptsDataSelectors } from "./scripts.selectors";
import { SCRIPTS_COLUMNS_CONFIG } from "./scripts.tables";

import { normalizeScript } from "../common/normalizeUtils";

const scriptInclude = [
  {
    relation: "SystemDictionary",
    scope: {
      fields: ["id", "envName", "envType", "envAddress"],
    },
  },
  {
    relation: "AppUser",
    scope: {
      fields: ["id", "username"],
    },
  },
  {
    relation: "Datasource",
  },
  {
    relation: "WorkItems",
  },
  {
    relation: "Tag",
  },
  {
    relation: "GlobalVariablesScriptsMap.GlobalVariable",
  },
];

const scriptEpics = {
  ...createModuleEpics<Script>(moduleActions, {
    normalizeItem: normalizeScript,
    getRequestParams: (state, tableId) => {
      const tableParams = scriptsDataSelectors.getParamsSelector(state, tableId!);
      const params = createRequestParams(tableParams, SCRIPTS_COLUMNS_CONFIG);

      params.filter = {
        ...params.filter,
        include: scriptInclude,
      };

      return params;
    },
    getSingleRequestParams: (params, state) => {
      params.filter = {
        ...params.filter,
        include: scriptInclude,
      };

      return params;
    },
    api: {
      createItem: API.createScript as any,
      deleteItem: API.deleteScript,
      editItem: (script, options) => API.editScript({ script, options } as any) as any,
      getItems: API.getScripts as any,
      getItemsCount: API.getScriptsCount,
    },
  }),
  closeScriptEpic: makeAsyncEpic(scriptsActionCreators.close, (payload) =>
    API.closeScript(payload),
  ),
};

export default scriptEpics;
